import request from '@/utils/request'

export function getHytkHytkList(data) {
  return request({
    url: '/api/Extend/LqHytkHytk',
    method: 'get',
    data
  })
}

export function getHytkHytkInfo(id) {
  return request({
    url: `/api/Extend/LqHytkHytk/${id}`,
    method: 'get'
  })
}

export function createHytkHytk(data) {
  return request({
    url: '/api/Extend/LqHytkHytk',
    method: 'post',
    data
  })
}
